module.exports = __webpack_public_path__ + "static/SUPPORT.5e62ef97.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/SUPPORT.pdf
// module id = 346
// module chunks = 1135276415346